import * as React from 'react';
import { PortalHeader, PortalFooter } from 'components/PortalStructure';
import Helmet from 'react-helmet';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { getShoppingBasket } from 'redux/modules/cart';
import { ICartAction, ICart } from 'models/cart/cart';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
const { asyncConnect } = require('redux-connect');
const config = require('../../../../../../../config/main');
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage, IAuthContext } from 'models/common';
import { setInitialData } from 'redux/modules/user/userpreferences';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IModalAction } from 'models/modal';
import { showModal, closeModal } from 'modules/modal';
import { IExtendedRouteProps } from 'routes/extendedroute';
import { RouteComponentProps } from 'react-router';
import { isRestrictedModeQuery } from 'redux/modules/shop/helpers';

interface IProps extends RouteComponentProps<any, any> {
	cart?: ICart;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	context: IAuthContext;
	userLanguage: IUserLanguage;
	languageDomainValues?: ILanguage[];
	getShoppingBasket?: () => ICartAction;
	setInitialData?: (isAuthenticated: boolean) => void;
	t?: (key: string) => string;
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect(
	(store: IStore) => ({
		cart: store.cart,
		userLanguage: store.userLanguage,
		languageDomainValues: store.domainValues.languages,
		baseUrlClient: store.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		getShoppingBasket: () => dispatch(getShoppingBasket()),
		setInitialData: (isAuthenticated: boolean) => dispatch(setInitialData(isAuthenticated)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalBaseLayoutComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.userLanguage.hackFlagDispatched !== this.props.userLanguage.hackFlagDispatched &&
			this.props.location.pathname === '/salons'
		) {
			this.redirectHome(null, this.props.userLanguage.languageKey);
		}
	}

	public redirectHome(_, languageKey: number) {
		const culture = languageKey
			? this.props.languageDomainValues.find((x) => x.key === languageKey).culture
			: this.props.userLanguage.culture;

		if (culture) {
			if (this.props.location && this.props.location.query && this.props.location.query.isDeactivateUser === 'true') {
				this.props.showModal('DeactivateUser', { closeModal: this.props.closeModal, step: 3 });
			}
			// browserHistory.push('/home/' + culture.substring(0, 2));
		}
	}

	public componentDidMount() {
		const isAuthenticated = this.props.context.isAuthenticated();
		this.props.setInitialData(isAuthenticated as boolean);
		// this.props.getShoppingBasket();
	}

	public render() {
		const { t } = this.props;
		const route: IExtendedRouteProps = this.props.routes?.length
			? this.props.routes[this.props.routes.length - 1]
			: this.props.route;
		const restrictedMode = route?.restrictedMode || isRestrictedModeQuery(this.props.location);
		const darkFooter = route?.darkFooter;
		const noFooter = route?.noFooter;

		return (
			<>
				<Helmet
					title={t('Portal_MetaTag_DefaulTitle')}
					link={[{ rel: 'canonical', href: t('Portal_MetaTag_DefaultUrl') }]}
					meta={[
						{ property: 'og:type', content: 'website' },
						{ property: 'og:title', content: t('Portal_MetaTag_DefaulTitle') },
						{ property: 'og:image', content: this.props.baseUrlClient + '/images/logo.png' },
						{ property: 'og:description', content: t('Portal_MetaTag_DefaultDescription') },
						{ property: 'og:url', content: t('Portal_MetaTag_DefaultUrl') },
						{ name: 'title', content: t('Portal_MetaTag_DefaulTitle') },
						{ name: 'description', content: t('Portal_MetaTag_DefaultDescription') },
						{ name: 'keywords', content: t('Portal_MetaTag_DefaultKeywords') },
					]}
				>
					<script type="text/javascript">
						{`if (window && document) {
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','` +
							config.app.googleSettings.tagManagerId +
							`');
                        }`}
					</script>

					<script type="text/javascript">
						{`if (window && document) {
                            window.fbAsyncInit = function () {
                                FB.init({
                                    appId:` +
							config.app.FBSettings.appId +
							`,
                                    autoLogAppEvents: true,
                                    xfbml: true,
                                    version: 'v2.7'
                                })
                            };

                            (function (d, s, id) {
                                var js, fjs = d.getElementsByTagName(s)[0];
                                if (d.getElementById(id)) { return; }
                                js = d.createElement(s); js.id = id;
                                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                                fjs.parentNode.insertBefore(js, fjs); 
                            }(document, 'script', 'facebook-jssdk'));
                        }
                    `}
					</script>
					{/* Meta Pixel Code */}
					<script type="text/javascript">
						{`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${config.app.FBSettings.pixelId}');
            fbq('track', 'PageView');
            `}
					</script>
					{/* End Meta Pixel Code */}
				</Helmet>

				<noscript>
					<iframe
						src={'https://www.googletagmanager.com/ns.html?id=' + config.app.googleSettings.tagManagerId}
						height="0"
						width="0"
						style={{ display: 'none', visibility: 'hidden' }}
					/>
				</noscript>
				<noscript>
					<img
						height="1"
						width="1"
						style={{ display: 'none' }}
						src={`https://www.facebook.com/tr?id=${config.app.FBSettings.pixelId}&ev=PageView&noscript=1`}
					/>
				</noscript>

				<PortalHeader />
				{this.props.children}
				<PortalFooter restrictedMode={restrictedMode} darkFooter={darkFooter} noFooter={noFooter} />
			</>
		);
	}
}

const PortalBaseLayout = withAuthContext(PortalBaseLayoutComponent);

export { PortalBaseLayout };
